<div class="profile-picture" [ngStyle]="styleContainer">
  <div class="profile-picture__profile" [ngStyle]="styleProfile">
    <img class="profile__img" [src]="content.path" [alt]="content.text" [ngStyle]="stylePicture" />
    <div class="profile__form" [ngStyle]="styleForm">
      <svg width="255" height="265" viewBox="0 0 255 265" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M143.35 0.774248C91.9942 -2.81166 40.1813 27.1211 16.2762 72.7232C-7.62894 118.325 -3.05121 177.037 26.3419 219.31C41.3542 240.9 63.42 258.823 89.3509 263.253C129.664 270.155 168.747 243.246 193.443 210.625C215.074 182.023 260.725 123.334 253.405 84.0143C244.734 37.5586 186.611 3.77828 143.35 0.774248Z" fill="currentColor"/>
      </svg>
    </div>
  </div>
</div>